import './confirmInsuranceModal.css'

import { Button } from 'react-bootstrap'

export default function ConfirmInsuranceModal({ onSkipInsurance, onAddInsurance }) {
  return (
    <div className='insurance-modal-bcg'>
      <div className='insurance-modal'>
        <h4>היי שיפטנבולים!</h4>
        <div style={{ marginBottom: '10px' }}>
          ראינו שבחרתם שלא לבטח את המשלוח.
          <br />
          אנחנו ממליצים לבטח בהשקעה קטנה ובתמורה גדולה!
          <br />
          סמכו עלינו זה לטובה :)
        </div>
        <div className='insurance-modal-footer'>
          <Button onClick={onAddInsurance} variant='outline-info'>
            חזרה
          </Button>{' '}
          <Button onClick={onSkipInsurance} variant='primary'>
            המשך
          </Button>
        </div>
      </div>
    </div>
  )
}
